import React from 'react';
import PropTypes from 'prop-types';

import CloseIcon from '@material-ui/icons/Close';

import IconButton from '../IconButton/IconButton';
import { StyledDialogTitle, IconButtonContainer } from './DialogTitle.styled';

const DialogTitle = ({ children, onClose, closeIcon, padding }) => (
  <StyledDialogTitle disableTypography padding={padding}>
    <div className="dialog-title-area">{children}</div>
    {closeIcon && (
      <IconButtonContainer>
        <IconButton
          label="Close Dialog"
          disableRipple
          onClick={onClose}
          icon={CloseIcon}
          size="xSmall"
        />
      </IconButtonContainer>
    )}
  </StyledDialogTitle>
);

DialogTitle.defaultProps = {
  closeIcon: true,
};

DialogTitle.propTypes = {
  closeIcon: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  padding: PropTypes.string,
};

export default React.memo(DialogTitle);
